import { render, staticRenderFns } from "./NLChartRow.vue?vue&type=template&id=2f6c20e4&scoped=true"
import script from "./NLChartRow.vue?vue&type=script&lang=js"
export * from "./NLChartRow.vue?vue&type=script&lang=js"
import style0 from "./NLChartRow.vue?vue&type=style&index=0&id=2f6c20e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c20e4",
  null
  
)

export default component.exports